import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { JournalEntry, Rating } from './challenge.model';

@Component({
    selector: 'app-daily-journal',
    templateUrl: './daily-journal.component.html',
    styleUrls: ['./daily-journal.component.scss'],
    standalone: false
})
export class DailyJournalComponent implements OnChanges, OnDestroy {
  @Input() entry: JournalEntry | null = null;
  @Output() textChange = new EventEmitter<string>();
  @Output() generalRatingChange = new EventEmitter<Rating | null>();
  @Output() happinessRatingChange = new EventEmitter<Rating | null>();

  draftText = '';
  hoverGeneral = 0;
  hoverHappiness = 0;
  happinessEmojis = ['😢', '😐', '🙂', '😀', '😁'];

  private textTimeout: ReturnType<typeof setTimeout> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entry']) {
      this.draftText = this.entry?.text ?? '';
    }
  }

  ngOnDestroy(): void {
    if (this.textTimeout) {
      clearTimeout(this.textTimeout);
      this.textChange.emit(this.draftText);
    }
  }

  onTextInput(value: string) {
    this.draftText = value;
    if (this.textTimeout) clearTimeout(this.textTimeout);
    this.textTimeout = setTimeout(() => {
      this.textChange.emit(this.draftText);
      this.textTimeout = null;
    }, 500);
  }

  onTextBlur() {
    if (this.textTimeout) { clearTimeout(this.textTimeout); this.textTimeout = null; }
    this.textChange.emit(this.draftText);
  }

  setGeneral(value: Rating) {
    if (this.entry?.generalRating === value) {
      this.generalRatingChange.emit(null);
    } else {
      this.generalRatingChange.emit(value);
    }
  }

  setHappiness(value: Rating) {
    if (this.entry?.happinessRating === value) {
      this.happinessRatingChange.emit(null);
    } else {
      this.happinessRatingChange.emit(value);
    }
  }

  starState(idx: number): 'filled' | 'empty' {
    const effective = this.hoverGeneral || (this.entry?.generalRating ?? 0);
    return idx <= effective ? 'filled' : 'empty';
  }

  happinessState(idx: number): 'active' | 'inactive' {
    const effective = this.hoverHappiness || (this.entry?.happinessRating ?? 0);
    return idx === effective ? 'active' : 'inactive';
  }
}
